module.exports = __webpack_public_path__ + "img/mengjinquAppImage.649a4a80.png";